<template>
  <div class="columns is-multiline">
    <div class="column is-3" v-for="slip in slips">
      <figure class="image is-autoby200">
        <img v-document="slip.document">
      </figure>
      <div class="columns receipt_footer">
        <div class="column">
          <div class="box-footer">
            <h6 class="title is-6 spacing-top-10 spacing-bottom-10 is-pulled-left no-margin-bottom">Nr. {{slip.number}}</h6>
            <router-link v-permission="'admin'" class="button is-primary is-pulled-right" :to="{ name: 'creditcard.confirmation.watch', params: { id: slip.id } }" exact>Bekijken</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-padding-fix column is-5" v-if="slips.length <= 0">
      <article class="message is-info">
        <div class="message-header">
          <p>Geen slips gevonden</p>
        </div>
        <div class="message-body">
          Sla een nieuwe bon op om gecontroleerd te worden.
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      slips: 'confirmationCreditcardslips'
    })
  },
  async created () {
    try {
      this.$store.dispatch('getConfirmationCreditcardslips')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens ophalen van de creditcard slips.'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/creditcard/confirmation/index.vue